import React, { useState, useEffect, memo } from 'react';
import { bet, standUp, foldHand, showHand } from './api';
import { TableState, SeatState } from './PokerTable';

interface Props {
  onStandup: () => void;
  tableState: TableState;
}

export default function({ onStandup, tableState }: Props) {
  const [amount, setAmount] = useState(0);
  const me = tableState.seats[tableState.mySeatIndex];
  const mySeatState = me.state;
  useEffect(() => {
    const me = tableState.seats[tableState.mySeatIndex];
    const myChips = me.chips;
    const myCurrentPot = me.currentPot;
    const maxBetAtTheTable = Math.max(
      ...tableState.seats.map(s => s.currentPot),
    );
    const toMatch = maxBetAtTheTable - myCurrentPot;
    setAmount(Math.min(toMatch, myChips));
  }, [tableState]);

  const haveCardsBeenDealt =
    me.cards.length === 2 && me.cards[0] !== '' && me.cards[1] !== '';
  return (
    <div className="actions">
      <div className="title">Player actions</div>
      <br />
      <div>
        <input
          disabled={mySeatState === SeatState.FOLDED}
          className="w-2-3"
          type="range"
          min="0"
          max={me.chips}
          value={amount}
          onChange={e => setAmount(parseInt(e.target.value, 10))}
        />
        <button
          className="w-1-3"
          disabled={mySeatState === SeatState.FOLDED || amount === 0}
          onClick={() => {
            bet(amount);
            setAmount(0);
          }}
        >
          Bet ${amount}
        </button>
      </div>
      <button
        className="w-1-2"
        disabled={mySeatState === SeatState.FOLDED || !haveCardsBeenDealt}
        onClick={foldHand}
      >
        Fold
      </button>
      <button
        className="w-1-2"
        disabled={mySeatState === SeatState.SHOW || !haveCardsBeenDealt}
        onClick={showHand}
      >
        Show
      </button>
      <br />
      <br />
      <button
        className="danger w-full"
        onClick={async () => {
          await standUp();
          onStandup();
        }}
      >
        Leave table
      </button>
    </div>
  );
}
